import script from "./SelectProductVariants.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectProductVariants.vue?vue&type=script&setup=true&lang=js"

import "./SelectProductVariants.vue?vue&type=style&index=0&id=4207f71c&lang=scss"

const __exports__ = script;

export default __exports__